//老师要求的两级提示

// import { msgbox } from "./smallarAlert.esm.js";
import { msgbox } from "~pjs/msgbox.esm.js";

const PA_info = '请确定先验概率P(Ai)和条件概率P(B|Ai)，这是计算全概率的必备条件';
const PB_info = '全概率即特征全概率，在已具备先验概率、条件概率的基础上进行全概率计算，<br>全概率公式：<br><img src="bayes_PB.png">';
const PC_info = '在已具备先验概率、条件概率、全概率的基础上进行后验概率的计算<br>后验概率公式:<br><img src="bayes-equation.png"> ';

const class_help_info = {
    "流沙入海":{
        1:[PA_info,'在案例中先验概率P(Ai)表示各河流的水量占比，条件概率P(B|Ai)表示某河流的含沙率。<br>已知这两个条件，才能计算某河流含沙与总水量之比，进而计算全概率'],
        2:[PB_info, '全概率的计算是后验概率计算前的关键一步，只有计算出全概率才能进行后验概率的计算。<br>在此案例中全概率表示总含沙与总水量之比，先验概率与条件概率的乘积表示某河流的含沙与总水量之比，<br>利用求和公式，就得到了特征全概率——海水含沙率'],
        3:[PC_info, '流沙入海案例，属于多因归一果、追根溯源的逆向求解问题。<br>后验概率的计算是贝叶斯计算中的最后一步，也是反映贝叶斯计算由果及因原理的关键一步。<br>此案例中，全概率P(B)表示大海含沙率，即总含沙与总水量之比，P(B|Ai)P(Ai)表示某河流的含沙与总水量之比，<br>相除就得到了某河流的含沙与总含沙之比，这就是我们的后验概率。'

        ]
    },
    "乳腺癌诊断":{
        1:[PA_info,'在案例中先验概率P(A1)、P(A2)分别表示乳腺癌患者和正常人分别在人群中的占比，<br>条件概率P(B|A1)、P(B|A2)分别表示乳腺癌患者和正常人检查结果阳性的概率。<br>已知这两个条件，才能计算检查结果阳性的乳腺癌患者和检查结果阳性的正常人在人群中的占比，进而计算全概率。'],
        2:[PB_info,'全概率的计算是后验概率计算前的关键一步，只有计算出全概率才能进行后验概率的计算。<br>在此案例中全概率表示人群中乳腺癌检查结果阳性的概率，先验概率与条件概率的乘积表示检查结果阳性的乳腺癌患者和检查结果阳性的正常人在人群中的占比，利用求和公式，就得到了特征全概率——人群中乳腺癌检查结果阳性率'],
        3:[PC_info,'乳腺癌诊断案例是基于检测信息判定检测真实情况的逆向求解问题，后验概率的计算是解决这一问题的关键。<br>此案例中，全概率P(B)表示人群中乳腺癌检查结果阳性率，P(B|Ai)P(Ai)表示检查结果阳性的乳腺癌患者和检查结果阳性的正常人在人群中的占比，<br>相除即可得到乳腺癌检查结果阳性的正误率，这就是后验概率。'],
    },
    "次品追责":{
        1:[PA_info,'在案例中先验概率P(Ai)表示产品来自不同工人的概率，条件概率P(B|Ai)表示不同工人的次品率。<br>已知这两个条件，才能计算不同工人生产的次品在所有产品中的占比，进而计算全概率'],
        2:[PB_info,'全概率的计算是后验概率计算前的关键一步，只有计算出全概率才能进行后验概率的计算。<br>在此案例中全概率表示所有产品的次品率，先验概率与条件概率的乘积表示不同工人生产的次品在所有产品中的占比，利用求和公式，就得到了特征全概率。'],
        3:[PC_info,'次品追责案例属于由果及因、追根溯源的逆向求解问题。后验概率的计算是贝叶斯计算中的最后一步，也是反映贝叶斯计算由果及因原理的关键一步。<br>此案例中，全概率P(B)表示所有产品的次品率。P(B|A_i)P(A_i)表示不同工人生产的次品在所有产品中的占比，<br>相除就得到次品来自不同工人的概率，这就是我们的后验概率。'],
    },
    "HIV筛查":{
        1:[PA_info,'在案例中先验概率P(A1)、P(A2)分别表示艾滋病患者和正常人分别在人群中的占比，<br>条件概率P(B|A1)、P(B|A2)分别表示艾滋病患者和正常人检查结果阳性的概率。<br>已知这两个条件，才能计算检查结果阳性的艾滋病患者和检查结果阳性的正常人在人群中的占比，进而计算全概率。'],
        2:[PB_info,'全概率的计算是后验概率计算前的关键一步，只有计算出全概率才能进行后验概率的计算。<br>在此案例中全概率表示人群中HIV检查结果阳性的概率，先验概率与条件概率的乘积表示检查结果阳性的艾滋病患者和检查结果阳性的正常人在人群中的占比，利用求和公式，就得到了特征全概率——人群中HIV检查结果阳性率'],
        3:[PC_info,'HIV筛查案例是基于检测信息判定检测真实情况的逆向求解问题，后验概率的计算是解决这一问题的关键。<br>此案例中，全概率P(B)表示人群中HIV检查结果阳性率，P(B|Ai)P(Ai)表示检查结果阳性的艾滋病患者和检查结果阳性的正常人在人群中的占比，相除即可得到HIV检查结果阳性的正误率，这就是后验概率。'],
    },
    "特征分类":{
        1:[PA_info,'在案例中先验概率P(Ai)表示人群中的男女比例，条件概率P(B|Ai)表示男性、女性中具有该特征的人数占比。<br>已知这两个条件，才能计算具有该特征的男性和女性在人群中的占比，进而计算全概率'],
        2:[PB_info,'全概率的计算是后验概率计算前的关键一步，只有计算出全概率才能进行后验概率的计算。在此案例中全概率表示人群中具有该特征的人数占比，先验概率与条件概率的乘积表示具有该特征的男性和女性在人群中的占比，利用求和公式，就得到了特征全概率。'],
        3:[PC_info,'特征分类案例属于由果及因、追根溯源的逆向求解问题。<br>后验概率的计算是贝叶斯计算中的最后一步，也是反映贝叶斯计算由果及因原理的关键一步。<br>此案例中，全概率P(B)表示人群中具有该特征的人数占比。P(B|Ai)P(Ai)表示具有该特征的男性和女性在人群中的占比，<br>相除就得到具有该特征的人是男性或是女性的概率，这就是我们的后验概率。']
    },
    "核酸检测":{
        1:[PA_info,"在案例中先验概率P(A1)、P(A2)分别表示新冠肺炎患者和正常人分别在人群中的占比，<br>条件概率P(B|A1)、P(B|A2)分别表示新冠肺炎患者和正常人核酸检测阳性的概率。<br>已知这两个条件，才能计算核酸检测阳性的新冠肺炎患者和核酸检测阳性的正常人在人群中的占比，进而计算全概率。"],
        2:[PB_info,"全概率的计算是后验概率计算前的关键一步，只有计算出全概率才能进行后验概率的计算。<br>在此案例中全概率表示人群中核酸检测阳性率，先验概率与条件概率的乘积表示核酸检测阳性的新冠肺炎患者和核酸检测阳性的正常人在人群中的占比，<br>利用求和公式，就得到了特征全概率——人群中核酸检测阳性率"],
        3:[PC_info,"核酸检测案例是基于检测信息判定检测真实情况的逆向求解问题，后验概率的计算是解决这一问题的关键。<br>此案例中，全概率P(B)表示人群中核酸检测阳性率，P(B|Ai)P(Ai)表示核酸检测阳性的新冠肺炎患者和核酸检测阳性的正常人在人群中的占比，<br>相除即可得到核酸检测阳性的正误率，这就是后验概率。"]
    },
    "empty":{
        1:[PA_info,'在案例中先验概率P(Ai)表示事件A各分类的占比，条件概率P(B|Ai)表示事件A第i个分类的特征的概率。<br>已知这两个条件，才能根据公式P(B|Ai)P(Ai)，计算“事件B来自事件A的第i个分类”占整体事件A的比值，进而计算全概率'],
        2:[PB_info,'全概率的计算是后验概率计算前的关键一步，全概率就是指事件A所有分类的特征率的总和，只有计算出全概率才能进行后验概率的计算'],
        3:[PC_info,'后验概率的计算是贝叶斯计算中的最后一步，也是反映贝叶斯计算由果及因原理的关键一步。<br>全概率P(B)表示事件A所有分类的特征率的总和，P(B|A_i)P(A_i)表示“事件B来自事件A的第i个分类”占整体事件A的比值，<br>相除就得到了事件B来自A的第i个分类的概率，这就是我们的后验概率']
    }


}

const class_help_fn = (name,who)=>{
    if(!class_help_info[name])name='empty';
    let msgs = class_help_info[name][who];
    idx_show(msgs,0);

    function idx_show(arr,idx){
        let title_level = ['提示','详细解释','详细解释','详细解释'];
        msgbox({
            type:'confirm',
            title:title_level[idx],
            msg:arr[idx],
            title_style:'text-align:center;display:none;',
           
            yes_txt:'明白了',
            no_txt:arr[idx+1]?(title_level[idx+1]):'仍不明白',
            has_close:false,
            callback:function(){console.log('understand')},
            callback2:function(){
                if(arr[idx+1]){
                    setTimeout(()=>idx_show(arr,idx+1),150);
                }else{
                    setTimeout(()=>msgbox({type:'alert',title:'没有提示了',title_style:'text-align:center',msg:'请认真观看学习视频、阅读学习资料，仔细思考。'}),150);
                }
            },

        })
    };

}
//案例引入
const case_introduce_list ={
    "流沙入海":`假设现在有一片海域，只有黄河，长江，珠江，黑龙江的河流汇入。已知四条河流汇入某个海域的概率分别是0.67、0.05、0.23、0.05，且长江含沙率为0.01，黄河含沙率为0.0378，珠江含沙率为0.006，黑龙江含沙率为0.002。<br>求这片海域的含沙率。<br>假设现在流入大海河流的水量和含沙率会变化，请你设想一下这片海域含沙率的变化。
        <br>你知道这片海里的一粒沙子究竟来自哪里吗？求沙子来自各河流的概率。
    `,
    "乳腺癌诊断":`1.全概率计算  已知全世界乳腺癌患病率为0.01，乳腺癌患者被正确诊断为乳腺癌的概率为0.8，乳腺癌患者被诊断为未患病的概率为0.2，而正常人被误判为乳腺癌的概率为0.1，你知道一个人被诊断为乳腺癌的概率是多少吗？<br>&emsp;2.后验概率计算  现某人被诊断为乳腺癌，则其为乳腺癌患者（即正确诊断）的概率是多少？医生诊断错误的概率是多少？`,
    "次品追责":`现有甲乙两个工厂生产同一批次的产品，且放在一起。已知某产品来自甲工厂的概率为0.4，来自乙工厂的概率为0.6，产品中含有次品，且甲工厂产生次品的概率为0.03，乙工厂产生次品的概率为0.02，你知道甲乙工厂生产的所有产品中产生次品的概率是多少吗？
    现某产品为次品，则其来自甲工厂的概率为多少？来自乙工厂的概率为多少？
    `,
    "核酸检测":`如今新冠肺炎全球肆虐，已知某时期全世界的新冠患病率为0.001，新冠患者核酸检测阳性的概率为0.95，然而正常人的核酸检测结果也可能出现阳性，其概率为0.02。现有一个人去做核酸检测，你知道他核酸检测结果阳性的概率是多少吗？
    现某人核酸结果显示阳性，则其为新冠患者的概率是多少？其为正常人的概率是多少？
    `,
    "HIV筛查":`已知HIV病人占据世界总人口的0.1%，HIV病人HIV病毒检测阳性的概率为0.95，然而正常人的HIV病毒核酸检测结果也可能出现阳性，正常人检测阳性的概率为0.01.现某人前往医院进行HIV病毒检测，你知道他的检测结果为阳性的概率是多少吗？
    现某人检测结果显示阳性，则其为HIV病人的概率是多少？其为正常人的概率是多少？
    `,
    "特征分类":`已知某村庄男女比例为1：1，男性食指长于无名指的概率为0.12，女性食指长于无名指的概率为0.85，求食指长于无名指的人在村庄的占比。
    已知村庄中某人食指长于无名指，则其为男性的概率是多少？是女性的概率是多少？
    `,
    "自定义事件":`自定义事件是由用户根据对贝叶斯的理解自定义计算卡片内容来进行求解，<br>不需要案例引入啦`
};
const case_introduce_list2 ={
    "流沙入海":`
        <img src="case_introduce/案例引入-流沙入海.png" style="width:700px;"/>
    `,
    "乳腺癌诊断":`<img src="case_introduce/案例引入-乳腺癌诊断.png" style="width:700px;"/> `,
    "次品追责":`<img src="case_introduce/案例引入-次品追责.png" style="width:700px;"/> `,
    "核酸检测":`<img src="case_introduce/案例引入-核酸检测.png" style="width:700px;"/>`,
    "HIV筛查":`<img src="case_introduce/案例引入-HIV筛查.png" style="width:700px;"/>`,
    "特征分类":`<img src="case_introduce/案例引入-特征分类.png" style="width:700px;"/>`,
    "自定义事件":`<img src="case_introduce/案例引入-自定义.png" style="width:700px;"/>`
}
const case_introduce_fn = function(name){
    if(!case_introduce_list2[name])name="自定义事件";
    msgbox({
        type:'alert',
        // title:'案例精选:' + name,
        title:'',
        contentBg:'transparent',
        bgColor:'rgba(0,0,0,0.3)',
        has_close:true,
        skin:'case-introduce',
        btn_css:{'font-size':'18px',padding:'4px 15px','border-radius':'14px',backgroundColor:'rgb(0,105,202)',transform:'translateY(-30px)'},
        msg:`${case_introduce_list2[name]}`,
        yes_txt:'已读'
    })
}
//我的反思

const html_str = `
请思考并回答以下问题，如果对答案不确定，可以在学习过程中随时返回修改你的回答：
1、流沙入海的案例中，要计算大海中的含沙率，需要知道哪几个关键的参数？
<textarea rows=2 id="feedback_q1" placeholder="我认为" style="width:83%;height:40px;margin-left:30px;"></textarea>
2、你在学习过程中遇到了哪些问题？是否尝试通过系统给出的案例视频或者提示得到帮助？请具体说明。
<textarea rows=2 id="feedback_q2" placeholder="我认为" style="width:83%;height:40px;margin-left:30px;"></textarea>
3、请阐述贝叶斯公式解决问题的原理，谈谈你对贝叶斯的理解。
<textarea rows=2 id="feedback_q3" placeholder="我认为" style="width:83%;height:40px;margin-left:30px;"></textarea>
4、参照流沙入海的例子，你是否从生活中选取其他熟悉的情境，提出应用贝叶斯公式的问题并列出相关算式?
<textarea rows=2 id="feedback_q4" placeholder="我认为" style="width:83%;height:40px;margin-left:30px;"></textarea>
<div id="feedback_user_info" style="display:none">感谢留下你的个人信息:
    <input style="font-size:20px;width:350px;margin-left:30px;" type="text" placeholder="输入个人信息或者联系方式" id="username"/>
    <input style="font-size:20px;width:350px;margin-left:30px;" type="text" placeholder="输入单位或者学校信息" id="school" style="display:none" value=""/>
</div>
`;
const answer ={
    'username':'',
    'school':'' ,
    'feedback_q1':'',
    'feedback_q2':'',
    'feedback_q3':'',
    'feedback_q4':'',
};
const save_answer = ()=>{for(let i in answer)answer[i] = $('#'+i).val().trim();}
const show_answer = ()=>{for(let i in answer)$('#'+i).val(answer[i])};

const my_think_fn = function(){
    msgbox({
        type:'confirm',
        title:'我的反思',
        title_style:'text-align:center;',
        msg:html_str,
        has_close:false,
        yes_txt:'提交',
        no_txt:'关闭',
        btn_css:{'color':'white',backgroundColor:'rgb(7,38,94)',padding:'5px 20px','borderRadius':'8px',marginLeft:'20px'},
        msg_style:'font-size: 20px;font-family: cursive;line-height: 38px;',
        callback:function(){
            console.log('my think');
            save_answer();
            if(answer.feedback_q1==='' && answer.feedback_q2==='' && answer.feedback_q3==='' && answer.feedback_q4===''){
                alert('失败，反馈信息为空');
                return;
            }
            let msg_info = {
                user:answer.username,school:answer.school,target:'bayes',
                msg:JSON.stringify(answer)
            }
            if(window.messager_send){
                messager_send('贝叶斯反思：'+JSON.stringify(answer));
            };
            let feedback_console = (location.protocol +"//" + location.hostname) + ":81/feedback_console";
            $.post(feedback_console,msg_info).done(function(res){
                console.log('res');
                if(res.status==='success'){
                    setTimeout(()=>{
                        msgbox({type:'pop',title:'成功',msg:'感谢反馈',show_time:1500});
                    },500)
                }else{
                    setTimeout(()=>{
                        msgbox({type:'pop',title:'失败',msg:'反馈失败：'+res.msg,show_time:2500});
                    },500)
                }
            }).fail(function(err){
                service_err_check(err,location.href);
            })
        },
        callback2:function(){
            console.log('隐藏');
            save_answer();
        }

    });
    let user = getCookie('user');
    if(!user){
        $('#feedback_user_info').show();
    }else{
        answer.username = user;
        answer.school = getCookie('school');
    }
    setTimeout(()=>{
        show_answer();
    },100)


}

//视频学习
const video_list ={
    '流沙入海':'BV1f44y1H7HQ',
    '乳腺癌诊断':'BV17R4y1L7B5',
    '次品追责':'BV18Y411V7dU',
    'HIV筛查':'BV1q5411o7k4',
    '特征分类':'BV1Vu411R7TY',
    '核酸检测':'BV1744y1p7ET',
}
const case_video_fn = (name)=>{
    let video_id = video_list[name];
    if(!video_id){
        msgbox({type:'pop',title:'没有发现视频配置',msg:'无视频',show_time:1500});
        return;
    }
    // let html_str = `<iframe src="//player.bilibili.com/player.html?aid=979080500&bvid=${video_id}&cid=510002972&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true" style="width:600px;height:450px"> </iframe>`;
    let html_str = `<iframe src="//player.bilibili.com/player.html?bvid=${video_id}" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true" style="width:40vw;height:50vh"> </iframe>`;
    if(!window.layer){
        random_load('/V-LAB/layer.js',case_video_fn(name));
        return;
    }else{
        layer.open({
            type:1,
            title:name,

            shade:0,
            content:html_str,
        })
    }
}

export {class_help_fn,case_introduce_fn,my_think_fn,case_video_fn}
